import { useEffect, useState } from 'react';

export const useIsActiveScroll = (): boolean => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const handleActive = () => {
      const position = window.scrollY;

      if (position > 0) {
        setIsActive(true);
      } else {
        setIsActive(false);
      }
    };

    handleActive();
    window.addEventListener('scroll', handleActive, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleActive);
    };
  }, []);

  return isActive;
};
